import React__default from 'react';

var InfoBlockText = function (_a) {
    var text = _a.text, setUppercase = _a.setUppercase;
    return (React__default.createElement("p", { className: "info-block-txt ".concat(setUppercase ? 'to-uppercase' : ''), title: text }, text));
};

export { InfoBlockText };
